(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mars3d"));
	else if(typeof define === 'function' && define.amd)
		define("mars3dWidget", ["mars3d"], factory);
	else if(typeof exports === 'object')
		exports["mars3dWidget"] = factory(require("mars3d"));
	else
		root["mars3dWidget"] = factory(root["mars3d"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 